import React from 'react';

const AdditionalInfo = ({ items }) => {
  return (
    <div id="additional-info" className="mt-20 border-t border-gray-200 pt-16">
      <div className="grid grid-cols-3 gap-12 mb-16">
        {(items || []).map((item, index) => (
          <div key={index} className="text-center">
            <div className="w-20 h-20 bg-premium-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className={`fa-solid ${item.icon} text-premium-gold text-3xl`}></i>
            </div>
            <h4 className="font-bold text-premium-dark mb-2">{item.title}</h4>
            <p className="text-gray-600 text-sm">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalInfo;
